$(document).ready(function(){
    var $heading = $('#store-locator-title');

    if ($heading.length && $heading.prop('tagName').toLowerCase() === 'h2') {
      $('<h1>', {
        id: $heading.attr('id'),
        html: $heading.html()
      }).replaceAll($heading);
    }
})